export const HEARTS_ANIMATION_GROUP = 'heartsAnimationGroup';
export const HEARTS_ANIMATION = 'heartsAnimation';
export const OUTLINED_ICON_TEST_ID = 'HeartIcon';
export const FILLED_ICON_TEST_ID = 'HeartFilledIcon';
//# sourceMappingURL=constants.js.map